// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName
import { application } from './application';

import ApiAutocompleteController from './api_autocomplete_controller.js';
import BankAccountToggleController from './users/bank_account_toggle_controller.js';
import CarouselStimulusController from './components/stimulus_carousel.js';
import ChangeDistributorController from './distributors/change_distributor_controller.js';
import CopyToClipboardController from './copy_to_clipboard_controller.js';
import DistributorFormController from './admin/users/distributors/form_controller.js';
import DropdownMenuController from './admin/dropdown_menu_controller.js';
import FundsCheckController from './admin/dashboard/funds_check_controller.js';
import GenerateTokenController from './generate_token_controller.js';
import InvestFormController from './invest_form_controller.js';
import LemonwayIframeController from './users/profile_information/onboarding/lemonway_iframe_controller.js';
import LendingTimetableFormController from './lending_time_table_controller.js';
import NativeInformationsFormCardController from './users/profile_information/native_informations_form_card_controller.js';
import NestedFormController from './nested_form_controller.js';
import PasswordVisibilityController from './password_visibility_controller.js';
import PoliticalExpositionController from './political_exposition_controller.js';
import ProjectSectionSelectorController from './admin/project_section_selector_controller.js';
import RedactorController from './redactor_controller.js';
import SidebarController from './sidebar_controller.js';
import SpecialPurposeVehicleFormController from './admin/special_purpose_vehicle_form_controller.js';
import TomSelectController from './tom_select_controller.js';
import TooltipController from './tooltip_controller.js';
import WelcomeModalController from './users/welcome_modal_controller.js';
import PhoneNumberController from './users/profile_information/phone_number_controller.js';
import ActiveRadioController from './users/profile_information/active_radio_controller.js';
import KycFileFeedbackController from './users/profile_information/kyc_documents/file_feedback_controller.js';
import SubscriptionModalController from './distributors/subscription_modal_controller.js';

application.register('api-autocomplete', ApiAutocompleteController);
application.register('carousel-stimulus', CarouselStimulusController);
application.register('political-exposition', PoliticalExpositionController);
application.register('tom-select', TomSelectController);
application.register('tooltip', TooltipController);
application.register('sidebar', SidebarController);
application.register('lending-timetable-form', LendingTimetableFormController);
application.register(
  'native-informations-form-card',
  NativeInformationsFormCardController
);
application.register('nested-form', NestedFormController);
application.register('redactor', RedactorController);
application.register('password-visibility', PasswordVisibilityController);
application.register(
  'project-section-selector',
  ProjectSectionSelectorController
);
application.register('lemonway-iframe', LemonwayIframeController);
application.register(
  'special-purpose-vehicle-form',
  SpecialPurposeVehicleFormController
);
application.register('invest-form', InvestFormController);
application.register('distributor-form', DistributorFormController);
application.register('dropdown-menu', DropdownMenuController);
application.register('generate-token', GenerateTokenController);
application.register('copy-to-clipboard', CopyToClipboardController);
application.register('funds-check', FundsCheckController);
application.register('welcome-modal', WelcomeModalController);
application.register('bank-account-toggle', BankAccountToggleController);
application.register('change-distributor', ChangeDistributorController);
application.register('phone-number', PhoneNumberController);
application.register('active-radio', ActiveRadioController);
application.register('kyc-file-feedback', KycFileFeedbackController);
application.register('subscription-modal', SubscriptionModalController);
